import React from 'react';
import './App.css';
import ReactDOM from "react-dom";
import {Button, Checkbox, Container, Dropdown, Input, List} from "semantic-ui-react";
import {CookiesProvider, useCookies} from 'react-cookie';
import Search from './Search.js';
import Capture from "./Capture";
import Inventory from "./Inventory";
import {sameRoad} from "./roadStability";

const format = require('format-duration')

const isLocalhost = typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
const debugLog = (...args) => { if (isLocalhost) console.log(...args); };

function displayLocation(location) {
    return location ? String(location).split("#")[0] : location;
}

function traceStart(caller, previous, next) {
    debugLog("[start-trace]", {caller, previousValue: previous, newValue: next});
}

const darkMode = "" +
    ":root { filter: invert();} " +
    "img {filter: invert();}" +
    "video {filter: invert();}" +
    "canvas {filter: invert();}";

let cookieOptions = {path: '/', expires: new Date(1427383583165000)};
const SITE_ID = "7853dd11-796d-4733-8c40-d748b95a9d88";

function roadDetails(road) {
    return `zone=${road.zone} portal=${road.portal} size=${road.size} expires=${road.expires.hours}h ${road.expires.minutes}m ${road.expires.seconds}s`;
}

function playAutoAddBeep() {
    try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (!AudioContext) return;
        const context = new AudioContext();
        const oscillator = context.createOscillator();
        const gain = context.createGain();
        oscillator.frequency.value = 880;
        gain.gain.value = 0.08;
        oscillator.connect(gain);
        gain.connect(context.destination);
        oscillator.onended = () => context.close().catch(() => {});
        oscillator.start();
        oscillator.stop(context.currentTime + 0.2);
        console.log("[auto-add] beep");
    } catch (error) {
        // Sound is optional when Web Audio is unavailable or blocked.
    }
}

function playBoop() {
    try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (!AudioContext) return;
        const context = new AudioContext();
        const oscillator = context.createOscillator();
        const gain = context.createGain();
        oscillator.frequency.value = 440;
        gain.gain.value = 0.08;
        oscillator.connect(gain);
        gain.connect(context.destination);
        oscillator.onended = () => context.close().catch(() => {});
        oscillator.start();
        oscillator.stop(context.currentTime + 0.06);
    } catch (error) {
        // Sound is optional when Web Audio is unavailable or blocked.
    }
}

function playBlurp() {
    try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (!AudioContext) return;
        const context = new AudioContext();
        const oscillator = context.createOscillator();
        const gain = context.createGain();
        oscillator.frequency.setValueAtTime(330, context.currentTime);
        oscillator.frequency.exponentialRampToValueAtTime(165, context.currentTime + 0.08);
        gain.gain.value = 0.08;
        oscillator.connect(gain);
        gain.connect(context.destination);
        oscillator.onended = () => context.close().catch(() => {});
        oscillator.start();
        oscillator.stop(context.currentTime + 0.08);
    } catch (error) {
        // Sound is optional when Web Audio is unavailable or blocked.
    }
}

const App = () => {
    return <Container>
            {window.location.pathname === "/search" ? <Search/> : <CookiesProvider><Login/></CookiesProvider>}
        </Container>
}

const Login = () => {
    const [cookies, setCookie] = useCookies(['cid']);
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("cid")) {
        setCookie('cid', urlParams.get("cid"), cookieOptions);
        if (window.history.replaceState) {
            window.history.replaceState(null, "", window.location.origin);
        }
        return <meta httpEquiv="refresh" content="0"/>
    }

    let path = window.location.pathname;
    return <Container>
            {!cookies.cid || cookies.cid === "" ?
                <div>
                    L
                    <h1><img src="roamapp-name.png" height="90" alt="ROAMapp" style={{margin: "20px"}}/></h1>
                    <style type="text/css">
                        {":root { background-color: #FFFFFF; }"}
                    </style>
                    <h3>If you are already on the ROAM discord, sign in.</h3>
                    <br/>
                    <a href="https://discord.com/api/oauth2/authorize?client_id=738922845421437008&redirect_uri=https%3A%2F%2Fdiscord.albionroamapp.com%2Fauth%2Fcallback&response_type=code&scope=identify%20guilds"
                       target="_self" title="Sign in with Discord">
                        <img src="log-in-with-discord.svg" alt="Sign in with Discord"/>
                    </a>
                    <br/>
                    <h3>Otherwise, first join the server using this link:</h3>
                    <br/>
                    <a href="https://discord.gg/BwQ5nUK" target="_blank" rel="noopener noreferrer"><img
                        src="join-our-discord.svg" alt="Join ROAM Discord"/></a>
                </div>
                : path === "/" ?
                    <Directions/> :
                    path === "/search" ?
                        <Search/> :
                        path === "/inventory" ?
                            <Inventory/> : ""
            }
        </Container>
}
const portalOptions = [
    {key: "F", text: "Fort Sterling", value: "F"},
    {key: "M", text: "Martlock", value: "M"},
    {key: "T", text: "Thetford", value: "T"},
    {key: "L", text: "Lymhurst", value: "L"},
    {key: "B", text: "Bridgewatch", value: "B"},
];

// Expirations match this regex as it is typed
const hoursMinutesEdit = /^(([0-2]?[0-9])(:([0-9][0-9]?)?)?)?$/;
const hoursMinutes = /^([0-2]?[0-9]):([0-5][0-9])$/;

function AddRoad(props) {
    const [road, setRoad] = React.useState("");
    const [roadExpires, setRoadExpires] = React.useState("");
    const [posX, setPosX] = React.useState(0);
    const [posY, setPosY] = React.useState(0);
    const {newRoad, roadAddedTick, submitRoad, start, setStart, locations, hoursMinutes, hoursMinutesEdit} = props;
    const roadExpiresField = React.createRef();
    const map = React.createRef();
    const startRef = React.useRef(start);
    startRef.current = start;

    function setRoadFromDropdown(event, dropdown) {
        setRoad(dropdown.value);
    }

    function updateRoadExpires(e, input) {
        let value = input.value;
        let matches = hoursMinutesEdit.exec(value);
        if (matches) {
            setRoadExpires(value);
        }
    }

    function ready() {
        let match = hoursMinutes.exec(roadExpires);
        return (start !== "" && road !== "" && match);
    }

    React.useEffect(() => {
        if (!newRoad || !newRoad.zone || String(newRoad.zone).trim() === "") {
            return;
        }
        ReactDOM.unstable_batchedUpdates(() => {
            traceStart("AddRoad useEffect", startRef.current, newRoad.zone);
            setStart(newRoad.zone);
            setRoad(newRoad.portal);
            const expires = newRoad.expires;
            if (expires && (expires.hours > 0 || expires.minutes > 0)) {
                const value = `${expires.hours}:${String(expires.minutes).padStart(2, "0")}`;
                let matches = hoursMinutesEdit.exec(value);
                if (matches) {
                    setRoadExpires(value);
                }
            }
        });
    }, [newRoad, setStart, hoursMinutesEdit]);

    React.useEffect(() => {
        if (!roadAddedTick) {
            return;
        }
        ReactDOM.unstable_batchedUpdates(() => {
            setPosX(0);
            setPosY(0);
            setRoadExpires("");
            setRoad("");
        });
    }, [roadAddedTick]);

    React.useEffect(() => {
        const canvas = map.current;
        if (canvas) {
            const ctx = canvas.getContext('2d');
            let rect = canvas.getBoundingClientRect();
            const w = canvas.width;
            const h = canvas.height;
            if (posY === 0 || posX === 0) {
                setPosX(rect.width / 2);
                setPosY(rect.height / 2);
                return;
            }
            ctx.clearRect(0, 0, w, h);
            ctx.beginPath();
            ctx.moveTo(.1 * w, h / 2);
            ctx.lineTo(w / 2, 0);
            ctx.lineTo(.9 * w, h / 2);
            ctx.lineTo(w / 2, h);
            ctx.closePath();
            ctx.fillStyle = 'lightgrey';
            ctx.fill();

            ctx.beginPath();
            ctx.ellipse(posX / rect.width * w, posY / rect.height * h, 10, 10, Math.PI / 4, 0, 2 * Math.PI);
            ctx.fillStyle = "blue";
            ctx.fill();
        }
    }, [map, posX, posY]);

    function setPosition(event) {
        const canvas = map.current;
        if (canvas) {
            let rect = map.current.getBoundingClientRect();
            let x = event.clientX - rect.left;
            let y = event.clientY - rect.top;
            setPosX(x);
            setPosY(y);
        }
    }

    async function addRoad() {
        if (ready()) {
            const canvas = map.current;
            if (canvas) {
                let rect = map.current.getBoundingClientRect();
                // Translate x and y from a h/2, h/2 center
                const transX = posX - rect.width / 2;
                const transY = posY - rect.height / 2;
                // Rotate -45
                const rotX = (transX + transY) / Math.sqrt(2);
                const rotY = (transY - transX) / Math.sqrt(2);
                const gameX = rotX / rect.width * 900 * Math.sqrt(2);
                const gameY = -rotY / rect.height * 900 * Math.sqrt(2);
                let match = hoursMinutes.exec(roadExpires);
                const added = await submitRoad({
                    zone: start,
                    portal: road,
                    size: 7,
                    expires: {
                        hours: parseInt(match[1]),
                        minutes: parseInt(match[2]),
                        seconds: 0,
                    },
                    posX: gameX,
                    posY: gameY,
                });
                if (added) {
                    ReactDOM.unstable_batchedUpdates(() => {
                        setPosX(0);
                        setPosY(0);
                        setRoadExpires("");
                        setRoad("");
                    });
                }
            }
        }
    }

    return <>
        {start !== "" ? <>
            <span style={{"display": "block"}}>Add Road in {displayLocation(start)}</span>
            <div className="roaddropdown">
                <Dropdown
                    placeholder='Target Road Location'
                    search
                    selection
                    value={displayLocation(road)}
                    onChange={setRoadFromDropdown}
                    options={locations}
                />
            </div>
            <canvas ref={map} onClick={setPosition} id="map"/>
            <br/>
            <Input ref={roadExpiresField} label="Expires in" onChange={updateRoadExpires} value={roadExpires}
                   size="mini" placeholder="HH:MM"/>
            <Button disabled={!ready()} style={{"display": "inline"}} onClick={addRoad} size="mini">Add</Button>
        </> : ""} </>;
}

const Directions = () => {
    const [start, setStart] = React.useState("");
    const urlParams = new URLSearchParams(window.location.search);
    const searchParam = urlParams.get("search");
    const [dest, setDest] = React.useState(searchParam ? searchParam.split(",") : []);
    const [locations, setLocations] = React.useState([]);
    const [directions, setDirections] = React.useState([]);
    const [resolvedDest, setResolvedDest] = React.useState("");
    const [distance, setDistance] = React.useState(0.0);
    const [wait, setWait] = React.useState(0.0);
    const [cookies, setCookie] = useCookies(['current', 'pl', 'roads', 'favorites', 'mode', 'norelock', 'excludes', 'fast', 'multi', 'dungeons']);
    const [currentLocation, setCurrentLocation] = React.useState(false);
    const [expires, setExpires] = React.useState(0);
    const expiresAtRef = React.useRef(null);
    const expiresIntervalRef = React.useRef(null);
    const findDirectionsRef = React.useRef(null);
    const [distances, setDistances] = React.useState({});
    const [waits, setWaits] = React.useState({});
    const [expirations, setExpirations] = React.useState({});
    const expirationDeadlinesRef = React.useRef({});
    const favoritesIntervalRef = React.useRef(null);
    const [reachableRoads, setReachableRoads] = React.useState(0);
    const [totalRoads, setTotalRoads] = React.useState(1);
    const [unexplored, setUnexplored] = React.useState([]);
    const [unexploredTypes, setUnexploredTypes] = React.useState({});
    const [reported, setReported] = React.useState([]);
    const mappedCacheRef = React.useRef(new Map());
    const [mappedVersion, setMappedVersion] = React.useState(0);
    const [status, setStatus] = React.useState(null);
    const [version, setVersion] = React.useState();

    const clearExpiresCountdown = React.useCallback(() => {
        if (expiresIntervalRef.current !== null) {
            window.clearInterval(expiresIntervalRef.current);
            expiresIntervalRef.current = null;
        }
        expiresAtRef.current = null;
        setExpires(0);
    }, []);

    const startExpiresCountdown = React.useCallback((expiresInSeconds) => {
        clearExpiresCountdown();
        if (!(expiresInSeconds > 0)) {
            return;
        }

        expiresAtRef.current = Date.now() + expiresInSeconds * 1000;
        setExpires(expiresInSeconds);
        expiresIntervalRef.current = window.setInterval(() => {
            const remaining = Math.max(0, Math.ceil((expiresAtRef.current - Date.now()) / 1000));
            setExpires(remaining);
            if (remaining <= 0) {
                window.clearInterval(expiresIntervalRef.current);
                expiresIntervalRef.current = null;
                expiresAtRef.current = null;
                if (findDirectionsRef.current) {
                    findDirectionsRef.current();
                }
            }
        }, 1000);
    }, [clearExpiresCountdown]);

    const clearFavoriteExpirationsCountdown = React.useCallback(() => {
        if (favoritesIntervalRef.current !== null) {
            window.clearInterval(favoritesIntervalRef.current);
            favoritesIntervalRef.current = null;
        }
        expirationDeadlinesRef.current = {};
        setExpirations({});
    }, []);

    const startFavoriteExpirationsCountdown = React.useCallback((deadlines, now = Date.now()) => {
        clearFavoriteExpirationsCountdown();
        expirationDeadlinesRef.current = deadlines;
        const initialExpirations = {};
        Object.entries(deadlines).forEach(([favorite, deadline]) => {
            initialExpirations[favorite] = format(Math.max(0, deadline - now));
        });
        setExpirations(initialExpirations);

        if (Object.keys(deadlines).length === 0) {
            return;
        }

        favoritesIntervalRef.current = window.setInterval(() => {
            const nextExpirations = {};
            const currentDeadlines = expirationDeadlinesRef.current;
            const tickNow = Date.now();
            let anyExpired = false;
            Object.entries(currentDeadlines).forEach(([favorite, deadline]) => {
                const remaining = deadline - tickNow;
                if (remaining <= 0) {
                    delete currentDeadlines[favorite];
                    nextExpirations[favorite] = "0:00";
                    anyExpired = true;
                } else {
                    nextExpirations[favorite] = format(remaining);
                }
            });
            setExpirations(nextExpirations);

            if (Object.keys(currentDeadlines).length === 0) {
                window.clearInterval(favoritesIntervalRef.current);
                favoritesIntervalRef.current = null;
            }
            if (anyExpired && findDirectionsRef.current) {
                findDirectionsRef.current();
            }
        }, 1000);
    }, [clearFavoriteExpirationsCountdown]);

    React.useEffect(() => {
        clearExpiresCountdown();
        clearFavoriteExpirationsCountdown();
        return () => {
            clearExpiresCountdown();
            clearFavoriteExpirationsCountdown();
        };
    }, [dest, clearExpiresCountdown, clearFavoriteExpirationsCountdown]);
    const [currentVersion, setCurrentVersion] = React.useState();
    const [newRoad, setNewRoad] = React.useState();
    const [roadAddedTick, setRoadAddedTick] = React.useState(0);
    const [stableRoadCount, setStableRoadCount] = React.useState(0);
    const [autoAdding, setAutoAdding] = React.useState(false);
    const previousRoadRef = React.useRef(null);
    const stableRoadCountRef = React.useRef(0);
    const lastHandledRoadRef = React.useRef(null);
    const autoAddInFlightRef = React.useRef(new Set());
    const instructionsText = React.createRef();

    const isWatchCurrentLocation = React.useCallback(() => {
        return cookies.current === "current";
    }, [cookies]);

    React.useEffect(() => {
        if (currentLocation !== isWatchCurrentLocation()) {
            setCurrentLocation(isWatchCurrentLocation());
        }
    }, [currentLocation, isWatchCurrentLocation])

    React.useEffect(() => {
        function getVersion() {
            return fetch(
                "https://api.albionroamapp.com/version?site_id=" + SITE_ID
            ).then(response => response.json()).then(result => {
                const version = result.version;
                setVersion(version);
            }).catch(() => {});
        }

        getVersion();

        let interval = setInterval(() => {
            getVersion();
        }, 600000);

        return () => {
            clearInterval(interval);
        }
    }, []);

    React.useEffect(() => {
        if (!currentVersion && version) {
            setCurrentVersion(version);
        } else if (currentVersion && version) {
            if (currentVersion !== version) {
                console.log("Version updated, reloading");
                window.location.reload();
            }
        }
    }, [version, currentVersion]);

    const runningAutocomplete = React.useRef(false);
    React.useEffect(() => {
        if (!runningAutocomplete.current) {
            runningAutocomplete.current = true;
            fetch(
                "https://ws5xuno6ue.execute-api.us-west-2.amazonaws.com/default/albion_roamapp",
                {
                    method: "GET"
                }
            ).then(response => {
                return response.json();
            }).then(data => {
                runningAutocomplete.current = false;
                const locations = data.autocomplete.map(l => {
                    return {
                        key: l.trim(), value: l.trim(), text: l.trim()
                    }
                });
                setLocations(locations);
            });
        }
    }, []);

    const isRoads = React.useCallback(() => {
        return cookies.roads === "roads";
    }, [cookies]);

    const isMultiSelect = React.useCallback(() => {
        return cookies.multi === "multi" || dest.length > 1;
    }, [cookies, dest.length]);

    const isNoRelock = React.useCallback(() => {
        return cookies.norelock === "norelock";
    }, [cookies]);

    const isDungeons = React.useCallback(() => {
        return cookies.dungeons === "dungeons";
    }, [cookies]);

    const checkMapped = React.useCallback(async (from, to) => {
        if (!from || !to || from === to) return;
        const key = `${from}|${to}`;
        if (mappedCacheRef.current.has(key)) return;
        mappedCacheRef.current.set(key, "pending");
        try {
            const response = await fetch(
                "https://ws5xuno6ue.execute-api.us-west-2.amazonaws.com/default/albion_roamapp",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        "from": from,
                        "to": to,
                        "search": null,
                        "roads": isRoads() ? "roads" : "noroads",
                        "lock": cookies.pl,
                        "tos": null,
                        "cid": cookies.cid,
                        "norelock": isNoRelock() ? "norelock" : "relock",
                        "excludes": cookies.excludes,
                        "fast": cookies.fast,
                        "dungeons": isDungeons(),
                    })
                }
            );
            const data = await response.json();
            mappedCacheRef.current.set(key, !!(data.path && data.path.length !== 0));
            setMappedVersion(v => v + 1);
        } catch (error) {
            mappedCacheRef.current.delete(key);
        }
    }, [cookies, isRoads, isNoRelock, isDungeons]);

    const isMapped = React.useCallback((from, to) => {
        return mappedCacheRef.current.get(`${from}|${to}`) === true;
    }, []);

    const clearDirections = React.useCallback(() => {
        setDirections([]);
        setResolvedDest("");
        setDistance(0);
        clearExpiresCountdown();
        clearFavoriteExpirationsCountdown();
        setReachableRoads(0);
        setUnexplored([]);
        setTotalRoads(0);
        setReported([]);
    }, [clearExpiresCountdown, clearFavoriteExpirationsCountdown]);

    if (!cookies.roads) {
        setCookie('roads', 'roads', cookieOptions);
    }

    const findDirections = React.useCallback(() => {
        const abortController = new AbortController();
        if (start !== "" && dest !== "") {
            if (start === dest) {
                ReactDOM.unstable_batchedUpdates(() => {
                    setStatus("You have arrived.");
                    clearDirections();
                });
                return;
            }
            setStatus("Getting directions from " + displayLocation(start) + " to " + dest + "...");
            fetch(
                "https://ws5xuno6ue.execute-api.us-west-2.amazonaws.com/default/albion_roamapp",
                {
                    signal: abortController.signal,
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        "from": start,
                        "to": dest.length === 1 ? dest[0] : null,
                        "search": dest.length > 1 ? dest : null,
                        "roads": isRoads() ? "roads" : "noroads",
                        "lock": cookies.pl,
                        "tos": cookies.favorites == null ? null : cookies.favorites.map(f => Array.isArray(f) ? JSON.stringify(f) : f),
                        "cid": cookies.cid,
                        "norelock": isNoRelock() ? "norelock" : "relock",
                        "excludes": cookies.excludes,
                        "fast": cookies.fast,
                        "dungeons": isDungeons(),
                    })
                }
            ).then(response => response.json())
                .then(data => {
                    let path = data.path;
                    if (path && path.length !== 0) {
                        ReactDOM.unstable_batchedUpdates(() => {
                            setDirections(path);
                            setResolvedDest(data.name);
                            setDistance(data.distance);
                            setWait(data.wait ? data.wait : 0);
                            startExpiresCountdown(data.expires);
                            setReachableRoads(data.reachableRoads);
                            setTotalRoads(data.totalRoads);
                            let batch = data.batch;
                            if (batch) {
                                let distances = {};
                                let waits = {};
                                let expirationDeadlines = {};
                                const now = Date.now();
                                batch.forEach(r => {
                                    if (r.name.startsWith("[")) {
                                        r.name = JSON.parse(r.name);
                                    }
                                    waits[r.name] = r.wait !== 0 ? format(r.wait * 1000) : null;
                                    distances[r.name] = format(r.distance / 10 * 1000);
                                    if (r.expires > 0) {
                                        expirationDeadlines[r.name] = now + r.expires * 1000;
                                    }
                                });
                                setWaits(waits);
                                setDistances(distances);
                                startFavoriteExpirationsCountdown(expirationDeadlines, now);
                            }
                            if (data.unexplored) {
                                setUnexploredTypes(data.unexploredTypes);
                                setUnexplored(data.unexplored);
                                setReported(data.reported);
                            }
                            setStatus(null);
                        });
                    } else {
                        ReactDOM.unstable_batchedUpdates(() => {
                            setStatus("Path currently unknown. ROAM to discover more connections. Adding each road" +
                                " that you see in a zone will map out more directions.");
                            clearDirections();
                        });
                    }
                }).catch((error) => {
                if (!abortController.signal.aborted) {
                    setStatus("Fetching directions failed");
                }
            })
        }
        return () => abortController.abort();
    }, [start, dest, cookies, isRoads, isNoRelock, isDungeons, clearDirections, startExpiresCountdown, startFavoriteExpirationsCountdown]);

    findDirectionsRef.current = dest ? findDirections : null;

    React.useEffect(findDirections, [start, dest, cookies, isRoads, isNoRelock, isDungeons, findDirections]);

    const submitRoad = React.useCallback(async (road) => {
        const expires = road.expires;
        const endTime = Math.round(new Date().getTime() / 1000 +
            expires.hours * 3600 + expires.minutes * 60 + expires.seconds);
        const payload = {
            clientID: cookies.cid,
            sourceClusterDisplayName: road.zone,
            targetClusterDisplayName: road.portal,
            maxCapacity: "" + road.size,
            remainingCapacity: "" + road.size,
            posX: road.posX || 0,
            posY: road.posY || 0,
            endTime: "" + endTime,
        };
        setStatus("Adding " + displayLocation(road.portal) + "...");
        try {
            const response = await fetch(
                "https://albion.reznok.com/api/map/roa?v=1.3.1",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload)
                }
            );
            const result = await response.json();
            if (result.error) {
                setStatus(result.error);
                return false;
            }
            ReactDOM.unstable_batchedUpdates(() => {
                setStatus("Added " + displayLocation(road.portal) + ".");
                setNewRoad(null);
                setRoadAddedTick(tick => tick + 1);
                mappedCacheRef.current.clear();
                setMappedVersion(v => v + 1);
            });
            findDirections();
            return true;
        } catch (error) {
            setStatus("Adding " + displayLocation(road.portal) + " failed");
            return false;
        }
    }, [cookies.cid, findDirections]);

    const clearReportedZone = React.useCallback((zoneName) => {
        setUnexplored(unexploredZones => unexploredZones.filter(zone => zone !== zoneName));
        setReported(reportedZones => reportedZones.filter(zone => zone !== zoneName));
        Promise.all([
            submitRoad({
                zone: start,
                portal: zoneName,
                size: 7,
                expires: {hours: 0, minutes: 0, seconds: 0},
                posX: 0,
                posY: 0,
            }),
            submitRoad({
                zone: zoneName,
                portal: start,
                size: 7,
                expires: {hours: 0, minutes: 0, seconds: 0},
                posX: 0,
                posY: 0,
            }),
        ]);
    }, [start, submitRoad]);

    function updatePortalLock(event, list) {
        setCookie('pl', list.value, cookieOptions);
    }

    function updateRoadsCheckbox(event, checkbox) {
        let value = checkbox.checked ? "roads" : "noroads";
        setCookie('roads', value, cookieOptions);
    }

    const updateMultiSelect = React.useCallback((event, checkbox) => {
        let value = checkbox.checked ? "multi" : "single";
        setCookie('multi', value, cookieOptions);
    }, [setCookie]);

    function updateWatchCurrentLocation(event, checkbox) {
        let value = checkbox.checked ? "current" : "nocurrent";
        setCookie('current', value, cookieOptions);
    }

    function updateNoReLockCheckbox(event, checkbox) {
        let value = checkbox.checked ? "norelock" : "relock";
        setCookie('norelock', value, cookieOptions);
    }

    function updateDarkMode(event, checkbox) {
        let value = checkbox.checked ? "dark" : "light";
        setCookie('mode', value, cookieOptions);
    }

    function isDarkMode() {
        return cookies.mode === "dark";
    }

    function updateFastTravel(event, checkbox) {
        let value = checkbox.checked ? "fast" : "nofast";
        setCookie('fast', value, cookieOptions);
    }

    function updateDungeons(event, checkbox) {
        let value = checkbox.checked ? "dungeons" : "nodungeons";
        setCookie('dungeons', value, cookieOptions);
    }

    function isFastTravel() {
        return cookies.fast === "fast";
    }

    function addFavorite(value) {
        let favorites = cookies.favorites;
        if (favorites && value) {
            let hasFavorite = favorites.includes(value);
            if (!hasFavorite) {
                favorites.push(value);
                setCookie('favorites', favorites, cookieOptions);
            }
        } else {
            setCookie('favorites', [value], cookieOptions);
        }
    }

    function addDestToFavorites() {
        addFavorite(dest);
    }

    function addStartToFavorites() {
        addFavorite(displayLocation(start));
    }

    function setToFavorite(event, button) {
        const value = button.value;
        if (start === "") {
            const nextStart = Array.isArray(value) ? value[0] : value;
            traceStart("favorite button", start, nextStart);
            setStart(nextStart);
        } else {
            if (Array.isArray(value)) {
                setDest(value);
            } else {
                setDest([value]);
            }
        }
    }

    function excludeZone(exitId) {
        return () => {
            const zone = exitId.substring(exitId.lastIndexOf("@") + 1);
            fetch(
                "https://ws5xuno6ue.execute-api.us-west-2.amazonaws.com/default/albion_roamapp",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        "from": zone
                    })
                }
            ).then(response => response.json())
                .then(data => {
                    addExclude(data.name);
                });
        }
    }

    function addExclude(value) {
        let excludes = cookies.excludes;
        if (excludes && value) {
            let hasFavorite = excludes.includes(value);
            if (!hasFavorite) {
                excludes.push(value);
                setCookie('excludes', excludes, cookieOptions);
            }
        } else {
            setCookie('excludes', [value], cookieOptions);
        }
    }

    function removeExclude(event, button) {
        let excludes = cookies.excludes;
        if (excludes) {
            const index = excludes.indexOf(button.value);
            if (index > -1) {
                excludes.splice(index, 1);
                setCookie('excludes', excludes, cookieOptions);
            }
        }
    }

    function removeFavoriteDest(event, button) {
        let favorites = cookies.favorites;
        if (favorites) {
            const index = favorites.indexOf(button.value);
            if (index > -1) {
                favorites.splice(index, 1);
                setCookie('favorites', favorites, cookieOptions);
            }
        }
    }

    function moveUp(favorite) {
        let favorites = cookies.favorites;
        if (favorites) {
            const newFavorites = [...favorites];
            const index = newFavorites.indexOf(favorite);
            if (index > 0) {
                newFavorites[index] = favorites[index - 1];
                newFavorites[index - 1] = favorite;
                setCookie('favorites', newFavorites, cookieOptions);
            }
        }
    }

    function moveDown(favorite) {
        let favorites = cookies.favorites;
        if (favorites) {
            const newFavorites = [...favorites];
            const index = newFavorites.indexOf(favorite);
            if (index < newFavorites.length - 1) {
                newFavorites[index] = favorites[index + 1];
                newFavorites[index + 1] = favorite;
                setCookie('favorites', newFavorites, cookieOptions);
            }
        }
    }

    const StartDirections = React.useMemo(() => {
        function startLocation(event, {value}) {
            traceStart("startLocation dropdown", start, value);
            setStart(value);
        }

        return <>
            <div className="dropdown">
                <Dropdown
                    placeholder='Location'
                    search
                    selection
                    value={displayLocation(start)}
                    onChange={startLocation}
                    options={locations}
                />
            </div>
        </>
    }, [start, locations]);

    const DestDirections = React.useMemo(() => {
        function destLocation(event, {value}) {
            setDest(isMultiSelect() ? value : [value]);
        }

        return <>
            <Checkbox id='updateMultiSelect' disabled={dest.length > 1}
                      onChange={updateMultiSelect} checked={isMultiSelect()}/>Multiple Destinations<br/>
            <div className="dropdown">
                {isMultiSelect() ?
                    <Dropdown
                        placeholder='Location'
                        search
                        multiple
                        selection
                        value={dest}
                        onChange={destLocation}
                        options={locations}
                    />
                    :
                    <Dropdown
                        placeholder='Location'
                        search
                        selection
                        value={dest[0]}
                        onChange={destLocation}
                        options={locations}
                    />

                }
            </div>
        </>
    }, [dest, locations, isMultiSelect, updateMultiSelect]);

    function showHideInstructions(event) {
        event.preventDefault();
        const text = instructionsText.current;
        if (text) {
            if (text.style.display === "none") {
                text.style.display = "block";
            } else {
                text.style.display = "none";
            }
        }
    }

    const autoAddRoad = React.useCallback((road) => {
        const key = JSON.stringify([road.zone, road.portal, road.size,
            road.expires.hours, road.expires.minutes, road.expires.seconds]);
        if (isMapped(road.zone, road.portal)) {
            console.log(`[auto-add] skipped (already mapped) ${roadDetails(road)}`);
            return;
        }
        if (autoAddInFlightRef.current.has(key)) {
            console.log(`[auto-add] skipped (in-flight) ${roadDetails(road)}`);
            return;
        }

        console.log(`[auto-add] firing add for ${roadDetails(road)}`);
        autoAddInFlightRef.current.add(key);
        setAutoAdding(true);
        submitRoad(road).then(success => {
            if (success) playAutoAddBeep();
        }).finally(() => {
            autoAddInFlightRef.current.delete(key);
            setAutoAdding(autoAddInFlightRef.current.size > 0);
        });
    }, [isMapped, submitRoad]);

    const updateRoad = React.useCallback((road) => {
        if (!road) {
            previousRoadRef.current = null;
            stableRoadCountRef.current = 0;
            lastHandledRoadRef.current = null;
            setStableRoadCount(0);
            setNewRoad(null);
            return;
        }

        setNewRoad(road);
        if (sameRoad(lastHandledRoadRef.current, road)) {
            return;
        }
        lastHandledRoadRef.current = null;
        if (isMapped(road.zone, road.portal)) {
            lastHandledRoadRef.current = road;
            previousRoadRef.current = null;
            stableRoadCountRef.current = 0;
            setStableRoadCount(0);
            return;
        }

        const previousRoad = previousRoadRef.current;
        const matchesPreviousRoad = sameRoad(previousRoad, road);
        if (matchesPreviousRoad || !previousRoad) {
            playBoop();
        } else {
            playBlurp();
        }
        const count = matchesPreviousRoad
            ? stableRoadCountRef.current + 1
            : 1;
        previousRoadRef.current = road;
        stableRoadCountRef.current = count;
        setStableRoadCount(count);
        console.log(`[auto-add] stable ${count}/2 ${roadDetails(road)}`);

        if (count >= 2) {
            previousRoadRef.current = null;
            stableRoadCountRef.current = 0;
            setStableRoadCount(0);
            lastHandledRoadRef.current = road;
            autoAddRoad(road);
        }
    }, [autoAddRoad, isMapped]);

    const updateCurrentLocation = React.useCallback((location) => {
        if (!location || String(location).trim() === "") {
            return;
        }
        if (isWatchCurrentLocation()) {
            if (locations.some(cluster => cluster.value === displayLocation(location))) {
                if (start !== location) {
                    console.log("Setting new location: " + location);
                    traceStart("updateCurrentLocation", start, location);
                    setStart(location);
                    setNewRoad(null);
                }
            }
        }
    }, [locations, start, isWatchCurrentLocation]);

    return <div>
        <h1><a href="/"><img src={isDarkMode() ? "roamapp-name-dark.png" : "roamapp-name.png"} height="90"
                             alt="ROAMapp"
                             style={{margin: "20px"}}/></a></h1>
        <style type="text/css">
            {":root { background-color: #FFFFFF; }"}
            {isDarkMode() ? darkMode : ""}
        </style>
        <a href="/" style={{"display": "block"}} onClick={showHideInstructions}>Instructions</a>
        <div style={{"display": "none"}} ref={instructionsText} className="instructions-text">
            <ol>
                <li>To get directions, enter a start location and a destination. If a path is known, it will
                    display a list of exits to take.
                </li>
                <li>You can use the <span role="img" aria-label="favorite" title="favorite">⭐</span>
                    to add the start or destination to your list of favorites. Clicking on a
                    favorite will set it to your start locaiton if none is set or if start is set, it will set
                    it to your destination.
                </li>
                <li>When a start location is set, you can add a portal that you see in that zone using the form
                    below the destination. Enter the name of the portal, its size, when it expires in HH:MM format
                    and click on the map location on the right diamond.
                </li>
                <li>As you move through the game, you can click on the exit you just took to change zones to set
                    your start location to the new zone that you entered so you can add more portals.
                </li>
                <li>The search feature lets you find zones in the map that have properties that you are
                    interested in, like tier, features and type of zone.
                </li>
                <li>The portal lock can help you find paths that don't require a different lock.</li>
                <li>Setting fast travel will allow the pathing system to use cities to move to another city.</li>
                <li>No relock makes it so that you don't go into a city from the black zone and change your
                    current portal lock.
                </li>
                <li>Start Road Screen Capture will ask to you to share the Albion application. While sharing it will
                    monitor
                    the screen for the current location and when you hover over portals it will attempt to
                    automatically add them - hover for a few seconds if it doesn't work right away.
                </li>
            </ol>

        </div>
        <Checkbox id='updateWatchCurrentLocation'
                  onChange={updateWatchCurrentLocation} checked={isWatchCurrentLocation()}/>
        <span>&nbsp;Use Current Location&nbsp;</span>
        <br/>
        {StartDirections}
        <Button className="favorite-button" onClick={addStartToFavorites}><span role="img" aria-label="favorite"
                                                                                title="favorite">⭐</span></Button>
        <br/>
        {DestDirections}
        <Button className="favorite-button" onClick={addDestToFavorites}><span role="img" aria-label="favorite"
                                                                               title="favorite">⭐</span></Button>
        <AddRoad newRoad={newRoad} roadAddedTick={roadAddedTick} submitRoad={submitRoad} start={start} setStart={setStart} locations={locations}
                 hoursMinutes={hoursMinutes} hoursMinutesEdit={hoursMinutesEdit}/>
        <a style={{"display": "block"}} href="/search">Search</a>
        {status != null ? <span className="status"><br/><br/>{status}</span> : ""}
        <List className="directions">
            {directions.map((exit, index) => {
                const destinationZone = directions[index + 1]?.zone || (dest.length === 1 ? dest[0] : resolvedDest);
                const displayedDestination = destinationZone ? destinationZone.split("#")[0] : "";
                const sourceLabel = exit.maximum ? exit.zone : exit.name;
                const displayedSource = exit.maximum && sourceLabel ? sourceLabel.split("#")[0] : sourceLabel;
                const isDuplicateDestination = sourceLabel && displayedDestination
                    && sourceLabel.split("#")[0].toLowerCase() === displayedDestination.toLowerCase();
                const exitTooltip = exit.zone + ", " + exit.type + ", T" + exit.tier;
                const roadLabel = exit.name ? exit.name + " (" + exit.maximum + ")" : "";
                return <List.Item className="direction" key={exit.id + exit.name}>
                    <span onClick={() => {
                        traceStart("directions arrow click", start, exit.zone);
                        setStart(exit.zone);
                    }}
                          title={exit.maximum && roadLabel ? roadLabel + " — " + exitTooltip : exitTooltip}>{displayedSource || ""}{!isDuplicateDestination && <><span
                        className="dir-arrow"> → </span><span
                        className="dir-dest">{displayedDestination}</span></>}</span>
                    <span onClick={excludeZone(exit.id)} className="exclude" role="img" aria-label="exclude"
                          title="exclude zone">❌</span>
                </List.Item>
            })}
        </List>
        <span>{distance > 0 ? Math.round(distance) + " meters (" + format(distance / 10 * 1000) + " by Swiftclaw)" : ""}
            {wait > 0 ? " Waiting: " + format(wait * 1000) : ""}
        </span>
        <br/>
        {expires > 0 ? <span>{"Expires in " + format(expires * 1000)}<br/></span> : ""}
        {reachableRoads > 0 ?
            <span>{"Seen: " + reachableRoads + "/" + totalRoads + " " + Math.round(100 * reachableRoads / totalRoads) + "%"}<br/></span> : ""}
        <List>
            {unexplored.length > 0 ? <List.Item key="unexplored">Unexplored:</List.Item> : ""}
            {unexplored.map(cluster => {
                return <List.Item className="direction" key={cluster}
                                  title={unexploredTypes[cluster]["type"] + ", T" + unexploredTypes[cluster]["tier"]}><b>{cluster}</b>{start ? <span
                    onClick={() => clearReportedZone(cluster)} className="exclude" role="img" aria-label="clear"
                    title="clear reported/unexplored road">❌</span> : ""}</List.Item>
            })}
        </List>
        <List>
            {reported.length > 0 ? <List.Item key="unexplored">Reported:</List.Item> : ""}
            {reported.map(cluster => {
                return <List.Item className="direction" key={cluster}><b>{cluster}</b>{start ? <span
                    onClick={() => clearReportedZone(cluster)} className="exclude" role="img" aria-label="clear"
                    title="clear reported/unexplored road">❌</span> : ""}</List.Item>
            })}
        </List>
        {start && dest ? <><Button style={{"display": "block"}}
                                   onClick={findDirections}>Refresh</Button></> : ""}
        <br/>
        <List>
            {cookies.excludes && cookies.excludes.length > 0 ? <label>Excludes</label> : ""}
            {cookies.excludes && cookies.excludes.map(exclude => {
                return <List.Item key={exclude}>
                    <Button onClick={removeExclude} value={exclude}><span role="img"
                                                                          aria-label="remove">❌</span></Button>
                    <span>{exclude}</span>
                </List.Item>
            })}
        </List>
        <List>
            {cookies.favorites && cookies.favorites.length > 0 ? <label>Favorites</label> : ""}
            {cookies.favorites && cookies.favorites.map(favorite => {
                const favoriteLabel = Array.isArray(favorite) ? favorite.join(", ") : favorite;
                const favoriteTooltip = Array.isArray(favorite) ? favorite.join("\n") : favorite;
                return <List.Item className="listitem" key={favorite}>
                    <Button onClick={removeFavoriteDest} value={favorite} size="small"><span role="img"
                                                                                             aria-label="remove">❌</span></Button>
                    <Button onClick={setToFavorite} value={favorite} size="small" title={favoriteTooltip}>
                        <span className="favorite-label">{favoriteLabel}</span>
                    </Button>
                    <span id={favorite}>
                        {distances[favorite]}{waits[favorite] ? "+" + waits[favorite] : ""}
                        {expirations[favorite] != null ? (expirations[favorite] !== "0:00" ? " expires " + expirations[favorite] + " " : "") : ""}</span>
                    <div className="updown"><span onClick={() => moveUp(favorite)}>↑</span> <span
                        onClick={() => moveDown(favorite)}>↓</span></div>
                </List.Item>
            })}
        </List>
        <span>Portal Lock</span><br/>
        <Dropdown clearable options={portalOptions} selection onChange={updatePortalLock} value={cookies.pl}/>
        <br/>
        <Checkbox id='updateRoadsCheckbox'
                  onChange={updateRoadsCheckbox} checked={isRoads()}/>
        <span>&nbsp;Use Roads&nbsp;</span>
        <Checkbox id='updateNoRelockCheckbox'
                  onChange={updateNoReLockCheckbox} checked={isNoRelock()}/>
        <span>&nbsp;No relock</span>
        <br/>
        <Checkbox id='darkMode'
                  onChange={updateDarkMode} checked={isDarkMode()}/>
        <span>&nbsp;Dark Mode&nbsp;</span>
        <Checkbox id='fastTravel'
                  onChange={updateFastTravel} checked={isFastTravel()}/>
        <span>&nbsp;Fast travel</span>
        <br/>
        <Checkbox id='dungeons'
                  onChange={updateDungeons} checked={isDungeons()}/>
        <span>&nbsp;Dungeons</span>
        <br/>
        <Capture
            updateRoad={updateRoad}
            updateLocation={updateCurrentLocation}
            checkMapped={checkMapped}
            isMapped={isMapped}
            mappedVersion={mappedVersion}
            stableRoadCount={stableRoadCount}
            autoAdding={autoAdding}
        />
        <br/>
        <a href="/?cid=">Logout</a>
        <div className="privacy">
            <span className="privacy-link">Privacy</span>
            <List className="privacy-text">
                <List.Item>1. ROAMapper collects the current location and the Roads that you enter into the webapp
                    and associates them with your client id.</List.Item>
                <List.Item>2. ROAMapper does not collect your character name, guild, alliance, or any other
                    identifying
                    in game information about you.</List.Item>
                <List.Item>3. ROAM will not disclose to any 3rd-party routes that you map.</List.Item>
                <List.Item>4. Favorites, excluded zones, and other settings are stored only client side and not
                    stored
                    on the server.</List.Item>
                <List.Item>5. ROAM will purge all data associated with your client id at your request. Message us on
                    Discord.</List.Item>
            </List>
        </div>
        {version ? <span>Version: {version}</span> : ""}
    </div>;
};

let styleLink = document.createElement("link");
styleLink.rel = "stylesheet";
styleLink.href = "https://cdn.jsdelivr.net/npm/semantic-ui/dist/semantic.min.css";
document.head.appendChild(styleLink);

ReactDOM.render(
    <App>
    </App>,
    document.getElementById("root")
);

export default App;
